import {combineReducers, configureStore} from "@reduxjs/toolkit";
import appSlice from "./app-slice/AppSlice";
import lentaSlice from "./lenta-slice/LentaSlice"
import commentSlice from "./comment-slice/CommentSlice"
import profileSlice from './profile-slice/ProfileSlice'

const rootReducer = combineReducers({
    appStore: appSlice,
    lentaStore:lentaSlice,
    commentStore:commentSlice,
    profileStore:profileSlice

});

export function setupStore() {
    return configureStore({
        reducer: rootReducer
    });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
